// extracted by mini-css-extract-plugin
module.exports = {"image":"fittedImage_image__sZcps"};